import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
export const DatePickerModal = ({ value, onChange, onClose, }) => {
    const [month, setMonth] = useState(new Date().getMonth());
    const [year, setYear] = useState(new Date().getFullYear());
    const [yearInput, setYearInput] = useState(String(new Date().getFullYear()));
    // Parse initial date if provided
    useEffect(() => {
        if (value) {
            try {
                const parts = value.split('-');
                if (parts.length === 3) {
                    const y = parseInt(parts[0]);
                    const m = parseInt(parts[1]) - 1;
                    setYear(y);
                    setMonth(m);
                    setYearInput(String(y));
                }
            }
            catch {
                // Use default date
            }
        }
    }, [value]);
    const getDaysInMonth = (month, year) => {
        return new Date(year, month + 1, 0).getDate();
    };
    const getFirstDayOfMonth = (month, year) => {
        return new Date(year, month, 1).getDay();
    };
    const handlePrevMonth = () => {
        if (month === 0) {
            setMonth(11);
            setYear(year - 1);
            setYearInput(String(year - 1));
        }
        else {
            setMonth(month - 1);
        }
    };
    const handleNextMonth = () => {
        if (month === 11) {
            setMonth(0);
            setYear(year + 1);
            setYearInput(String(year + 1));
        }
        else {
            setMonth(month + 1);
        }
    };
    const handleYearChange = (e) => {
        const input = e.target.value;
        setYearInput(input);
        const numYear = parseInt(input);
        if (!isNaN(numYear) && numYear > 0) {
            setYear(numYear);
        }
    };
    const handleDayClick = (day) => {
        const dateStr = `${String(year).padStart(4, '0')}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        onChange(dateStr);
        onClose();
    };
    const handleToday = () => {
        const today = new Date();
        const dateStr = `${String(today.getFullYear()).padStart(4, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        onChange(dateStr);
        onClose();
    };
    const daysInMonth = getDaysInMonth(month, year);
    const firstDay = getFirstDayOfMonth(month, year);
    const days = Array(firstDay).fill(null);
    for (let i = 1; i <= daysInMonth; i++) {
        days.push(i);
    }
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const currentDate = new Date();
    const isToday = value && value === `${String(currentDate.getFullYear()).padStart(4, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
    return (_jsx("div", { className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50", onClick: onClose, children: _jsxs("div", { className: "bg-gray-800 rounded-lg p-6 w-full max-w-sm backdrop-blur-xl border border-white/20", onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "flex items-center justify-between mb-6", children: [_jsx("h2", { className: "text-lg font-semibold text-white", children: "Select Date" }), _jsx("button", { onClick: onClose, className: "text-gray-400 hover:text-white transition-colors", children: _jsx(X, { className: "w-5 h-5" }) })] }), _jsxs("div", { className: "flex items-center justify-between mb-6 gap-3", children: [_jsx("button", { onClick: handlePrevMonth, className: "p-2 hover:bg-white/10 rounded-lg transition-colors", children: _jsx(ChevronLeft, { className: "w-5 h-5 text-white" }) }), _jsxs("div", { className: "flex-1 text-center", children: [_jsx("div", { className: "text-white font-semibold mb-2", children: monthNames[month] }), _jsx("input", { type: "number", value: yearInput, onChange: handleYearChange, className: "w-full px-3 py-2 bg-black/20 border border-white/20 rounded text-white text-center font-medium focus:outline-none focus:border-blue-400", min: "1900", max: "2100" })] }), _jsx("button", { onClick: handleNextMonth, className: "p-2 hover:bg-white/10 rounded-lg transition-colors", children: _jsx(ChevronRight, { className: "w-5 h-5 text-white" }) })] }), _jsx("div", { className: "grid grid-cols-7 gap-2 mb-4", children: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (_jsx("div", { className: "text-center text-xs font-semibold text-gray-400 py-2", children: day }, day))) }), _jsx("div", { className: "grid grid-cols-7 gap-2 mb-6", children: days.map((day, index) => (_jsx("button", { onClick: () => day && handleDayClick(day), disabled: !day, className: `aspect-square rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${!day
                            ? 'cursor-default'
                            : `hover:bg-blue-500 cursor-pointer ${value === `${String(year).padStart(4, '0')}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
                                ? 'bg-blue-600 text-white'
                                : 'bg-black/20 text-white hover:bg-blue-500/30'}`}`, children: day }, index))) }), _jsxs("div", { className: "flex gap-2", children: [_jsx("button", { onClick: handleToday, className: `flex-1 px-4 py-2 rounded-lg transition-colors text-sm font-medium ${isToday
                                ? 'bg-blue-600 text-white'
                                : 'bg-blue-500/20 text-blue-300 hover:bg-blue-500/30'}`, children: "Today" }), _jsx("button", { onClick: onClose, className: "flex-1 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors text-sm font-medium", children: "Close" })] })] }) }));
};
export default DatePickerModal;
